import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useForm from '@components/form/hooks/useForm';

import { updateAdminUserPassword } from '@actions/adminUsers';
import { getAdminUserIsPosting, getAdminUserPostSuccess } from '@selectors/adminUsers';

export default function useUpdateAdminPassword(userID: number): UpdateAdminPasswordReturn {
    const dispatch = useDispatch();

    const [formState, handleChange] = useForm({ password: '', confirmPassword: '' });

    const handleSubmit = useCallback(() => {
        dispatch(updateAdminUserPassword(userID, formState));
    }, [dispatch, userID, formState]);

    const isPosting = useSelector(getAdminUserIsPosting);
    const postSuccess = useSelector(getAdminUserPostSuccess);

    return {
        handleSubmit,
        formState,
        handleChange,
        postSuccess,
        isPosting,
    };
}

interface FormState {
    password: string;
    confirmPassword: string;
}

interface UpdateAdminPasswordReturn {
    handleSubmit: () => void;
    formState: FormState;
    handleChange: <T>(name: 'password' | 'confirmPassword', value: T) => void;
    postSuccess: boolean;
    isPosting: boolean;
}
